import type { ResearchSessionManifest } from "../../lib/api";

type Artifact = ResearchSessionManifest["artifacts"][number];

export function ArtifactRenderer({ artifact }: { artifact: Artifact }) {
  if (artifact.renderer === "json") {
    return (
      <pre className="overflow-auto rounded-md border border-border bg-surface-2 p-3 text-[12px] leading-relaxed">
        {artifact.path}
      </pre>
    );
  }
  if (artifact.renderer === "image") {
    return (
      <img
        src={artifact.path}
        alt={artifact.title}
        className="max-h-[360px] rounded-md border border-border object-contain"
      />
    );
  }
  return (
    <a href={artifact.path} className="text-accent-ink hover:text-accent break-all">
      {artifact.title}
    </a>
  );
}
